import { render, staticRenderFns } from "./PendingBoxWebpart.vue?vue&type=template&id=7e34ed0d"
import script from "./PendingBoxWebpart.ts?vue&type=script&lang=ts&external"
export * from "./PendingBoxWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports